import React from "react";
import { Link } from "react-router-dom";
export default function Navbar() {
  return (
    <nav className="navbar">
      <Link to="/">
        <div className="home-logo">cocktails</div>
      </Link>
    </nav>
  );
}
